/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-vendor-payment-tracker.reducer';

export const PharmacyVendorPaymentTrackerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyVendorPaymentTrackerEntity = useAppSelector(state => state.pharmacyVendorPaymentTracker.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyVendorPaymentTrackerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.detail.title">PharmacyVendorPaymentTracker</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.id}</dd>
          <dt>
            <span id="settledAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.settledAmount">Settled Amount</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.settledAmount}</dd>
          <dt>
            <span id="transactionType">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.transactionType">Transaction Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.transactionType}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.modifiedById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.lastUpdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.returnPayment">Return Payment</Translate>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.returnPayment ? pharmacyVendorPaymentTrackerEntity.returnPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.purchasePayment">Purchase Payment</Translate>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.purchasePayment ? pharmacyVendorPaymentTrackerEntity.purchasePayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.parentCredit">Parent Credit</Translate>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.parentCredit ? pharmacyVendorPaymentTrackerEntity.parentCredit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.pharmacy ? pharmacyVendorPaymentTrackerEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.payedCredit">Payed Credit</Translate>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.payedCredit ? pharmacyVendorPaymentTrackerEntity.payedCredit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyVendorPaymentTrackerEntity.supplier ? pharmacyVendorPaymentTrackerEntity.supplier.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-vendor-payment-tracker" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-vendor-payment-tracker/${pharmacyVendorPaymentTrackerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyVendorPaymentTrackerDetail;
